/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pos_Quick_SaleInputs */

const vi_pos_quick_sale = /** @type {(inputs: Pos_Quick_SaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bán nhanh`)
};

/**

* @param {Pos_Quick_SaleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_quick_sale = /** @type {((inputs?: Pos_Quick_SaleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Quick_SaleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_quick_sale(inputs)
});